var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescarregando(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1227",
    "data-name": "Grupo 1227",
    transform: "translate(-22 7703)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_90",
    className: "circleIconState",
    "data-name": "Elipse 90",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(22 -7703)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_894",
    "data-name": "Caminho 894",
    d: "M522.408,201.626h-.121v-4.753a3.043,3.043,0,0,0-.11-.851,2.888,2.888,0,0,0-2.842-2.091c-1.642-.005-3.284,0-4.925,0a.821.821,0,0,0-.121.006,5.045,5.045,0,0,0-.156-.854,2.641,2.641,0,0,0-1.38-1.981c-.071-.033-.135-.079-.2-.117a21.625,21.625,0,0,0-4.475-1.848V196.8h3.7l-6.743,6.742-6.743-6.742h3.7v-8.523a24.955,24.955,0,0,0-7.05.98,1.379,1.379,0,0,0-.615.356,5.1,5.1,0,0,0-1.4,2.724,8.744,8.744,0,0,0,.014,3.24,1.3,1.3,0,0,0,.38.847,23.685,23.685,0,0,0,3.1,2.387c-1.211.3-2.541.642-2.541.642a.451.451,0,0,0-.451.45v5.241l2.525,0a2.175,2.175,0,0,0-.032.436,2.251,2.251,0,1,0,4.458-.433h1.047a2.288,2.288,0,0,0-.032.426,2.256,2.256,0,0,0,4.511-.045,2.207,2.207,0,0,0-.038-.375l9.38,0a2.25,2.25,0,1,0,4.471.35,2.2,2.2,0,0,0-.038-.35h3.065a.746.746,0,0,0,.116-.017v-3.081A.449.449,0,0,0,522.408,201.626Z",
    transform: "translate(-464.777 -7880.281)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescarregando);
export default __webpack_public_path__ + "static/media/Descarregando.1f47de5198bc1e0bbbba3d43a93a3b79.svg";
export { ForwardRef as ReactComponent };